import { httpRequest } from "@services/http";

export class CommandChangePassword {
    async run(password: string) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/auth/change-password/`;
        const body = {
            password
        };
        const response = await httpRequest(url, { method: "POST", body });
        return response;
    }
}